var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHalfPitch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "295px",
    height: "200px",
    viewBox: "0 0 295 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Trends",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Misconduct",
    transform: "translate(-17.000000, -1436.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "screen_content",
    transform: "translate(-23.000000, 146.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "section_position",
    transform: "translate(0.000000, 1199.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pitch",
    transform: "translate(40.000000, 91.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "assets/pitch_half"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Main-BG",
    fill: "#74B82A",
    fillRule: "evenodd",
    x: 0,
    y: 0,
    width: 295,
    height: 200
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shading-Vertical",
    fillOpacity: 0.1,
    fill: "#000000",
    fillRule: "evenodd",
    x: 101,
    y: 5,
    width: 95,
    height: 190
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Shading-Horizontal",
    fillOpacity: 0.1,
    fill: "#000000",
    fillRule: "evenodd",
    x: 6,
    y: 68,
    width: 285,
    height: 63.3333321
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Pitch-Perimeter",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    x: 6,
    y: 6,
    width: 283,
    height: 188
  }), /*#__PURE__*/React.createElement("rect", {
    id: "6-Yard-Box",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    x: 102,
    y: 175,
    width: 93,
    height: 19
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Penalty-Box",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    x: 56,
    y: 132.666668,
    width: 183,
    height: 61.3333321
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,113.327974 C119.469258,124.786561 133.076273,132.216997 148.418759,132.216997 C163.907139,132.216997 177.626885,124.644575 186.077727,113",
    id: "Penalty-Box-D",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    transform: "translate(148.538864, 122.608498) rotate(-180.000000) translate(-148.538864, -122.608498) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,5 C102,30.6812409 122.818759,51.5 148.5,51.5 C174.181241,51.5 195,30.6812409 195,5",
    id: "Centre-Circle",
    stroke: "#FFFFFF",
    strokeWidth: 2
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfPitch);
export default __webpack_public_path__ + "static/media/half-pitch.22347743990f3c8ee13234fcbd9f1813.svg";
export { ForwardRef as ReactComponent };